import { composeIO } from 'react-compose-io'
import { cardValorQuantidadeIO } from './CardValorQuantidade.IO'
import { CardValorQuantidadeView } from './CardValorQuantidade.View'

export const CardValorQuantidade = composeIO(CardValorQuantidadeView, cardValorQuantidadeIO)
